import { t } from "i18next";
import { useNavigation } from "@refinedev/core";
import { Button, Result } from "antd";
import { useBoundStore, useVolatileBoundStore } from "store";
import { Confetti } from "@phosphor-icons/react";
import { useAntTheme } from "hooks/useAntTheme";
import { useProjectNavigate } from "pages/media/projects/hooks/useProjectNavigate";

const Finish = () => {
  const { theme } = useAntTheme();
  const { list } = useNavigation();
  const { navigateToStoryboard } = useProjectNavigate();

  const { currentProjectId } = useVolatileBoundStore((state) => ({
    currentProjectId: state.projectState.currentProjectId,
  }));

  function handleClick() {
    // if projectId hasn't been set together with settings approval or if we open onboarding page directly and not from the settings approval
    if (!currentProjectId) {
      return list("media_projects");
    }
    navigateToStoryboard({
      projectId: currentProjectId,
      subRoute: "generating",
    });
  }

  useBoundStore((state) => {
    return {
      onboardingState: state.onboardingState,
      resetOnboardingState: state.resetOnboardingState,
    };
  });
  return (
    <Result
      style={{ paddingTop: "25vh" }}
      icon={<Confetti size={100} color={theme.colorPrimary} />}
      title={t("pages.onboarding.titles.finish")}
      extra={
        <Button type="primary" size="large" shape="round" onClick={handleClick}>
          {t("pages.onboarding.buttons.finish")}
        </Button>
      }
      status={"success"}
    />
  );
};

export default Finish;
